const translations = {
    connectionError: 'Connection error. Click to retry.',
    saveFailed: 'Save failed. Click to retry.'
};

export default translations;
